import { render, staticRenderFns } from "./ProductLevelNameList.vue?vue&type=template&id=3178bc85&scoped=true"
import script from "./ProductLevelNameList.vue?vue&type=script&lang=js"
export * from "./ProductLevelNameList.vue?vue&type=script&lang=js"
import style0 from "./ProductLevelNameList.vue?vue&type=style&index=0&id=3178bc85&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3178bc85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3178bc85')) {
      api.createRecord('3178bc85', component.options)
    } else {
      api.reload('3178bc85', component.options)
    }
    module.hot.accept("./ProductLevelNameList.vue?vue&type=template&id=3178bc85&scoped=true", function () {
      api.rerender('3178bc85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/product-score-rules/form/ProductLevelNameList.vue"
export default component.exports